export const nbsp = '\u00A0';
export const times = '\u00D7';
export const arrowUp = '\u25B2';
export const arrowDown = '\u25BC';
export const nonBreakingHyphen = '\u2011';
